import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppCommon } from '../api-providers/app-common';
import { AppComponent } from '../app.component';
import { LoginViewModel } from '../api-providers/view-models/login.view.model';
import { NzDrawerPlacement } from 'ng-zorro-antd/drawer';
import { NzBadgeModule } from 'ng-zorro-antd/badge';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @Input('isCollapsed') isCollapsed: boolean = true;
  page_size= 9 
  page=1
  userEmailsPermission :boolean=false;
  userDomainsPermission :boolean=false;
  userMyEmailsPermission :boolean=false;
  userBdayCardsPermission :boolean=false;
  notifications:any
  count:any
  notificationTitle:any
  @ViewChild(TemplateRef, { static: false }) template?: TemplateRef<{}>;
  visible = false;
  placement: NzDrawerPlacement = 'right';
  next:any
  loggedObject:any
  taskPermission:boolean=false;
  deploymentPermission:boolean=false;
  constructor(
    private router: Router,
    private authService: SocialAuthService) { 
  
    this.loggedObject = AppCommon.getloggedInObject();
    this.taskPermission = this.loggedObject?.user?.permission?.filter( e=> e.entity.includes('task'))?.length > 0  
    this.deploymentPermission = AppCommon.hasDeploymentPermission(this.loggedObject);
    
    this.userEmailsPermission = ['SuperAdmin', 'IT', 'Management'].some(role => AppCommon.getRole().includes(role));
    this.userMyEmailsPermission = ['General'].some(role => AppCommon.getRole().includes(role));
    this.userBdayCardsPermission = ['SuperAdmin','HR'].some(role => AppCommon.getRole().includes(role));
    // setInterval(() => {this.vm.getNotification(this.loggedObject.user.id,this.page_size,this.page)} , 5000)

   if(this.loggedObject?.user?.permission?.filter( e=> e.name.includes('View Domain'))?.length > 0 ||
    ['SuperAdmin', 'IT', 'Management'].some(role => AppCommon.getRole().includes(role))){
    this.userDomainsPermission = true ;
   }
  }

  ngOnInit(): void {
 
  }

  open(): void {
    this.visible = true;
  }


  setVisible(e:any){
    this.visible = false;
  }
  
  signOut(): void {
    AppCommon.clearStorage();
    this.authService.signOut();
    AppComponent.staticCall.isLoggedIn = false;
    this.router.navigate(['/login']);
  }

}
